/**
 * @generated SignedSource<<30e85eb36d3f1ccc3f9c49d825078005>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
type JobTitle_job$fragmentType = any;
import type { FragmentType } from "relay-runtime";
declare export opaque type JobLink_job$fragmentType: FragmentType;
export type JobLink_job$data = {|
  +url: string,
  +$fragmentSpreads: JobTitle_job$fragmentType,
  +$fragmentType: JobLink_job$fragmentType,
|};
export type JobLink_job$key = {
  +$data?: JobLink_job$data,
  +$fragmentSpreads: JobLink_job$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobLink_job",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "JobTitle_job"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "type": "JobTypeCommand",
  "abstractKey": null
};

(node/*: any*/).hash = "29baceaa72246eea727d093319db78bc";

module.exports = ((node/*: any*/)/*: Fragment<
  JobLink_job$fragmentType,
  JobLink_job$data,
>*/);
